import { useTestAB } from '@catalogo/core-experiments';
import React from 'react';
import { TShippingMessageComponent } from '../types';
import { CheapMoreShipping } from './cheap-more-shipping';
import { FreeShipping } from './free-shipping';

export const ShippingMessage: TShippingMessageComponent = ({
  index,
  freeShipping,
  isLoading,
  hasIncentiveForMoreCheapFreight,
  hasIncentiveForFreeShipping,
  quantityForFreeShipping,
}) => {
  const experiment = useTestAB('EXP_NS_03_TAG_FREE_SHIPPING_BY_QTY');
  const hasIncentive = index === 0 && !freeShipping;
  const showIncentiveForMoreCheapFreight = hasIncentiveForMoreCheapFreight && hasIncentive;
  const showIncentiveForFreeShipping = hasIncentiveForFreeShipping && hasIncentive;

  if (showIncentiveForMoreCheapFreight && !quantityForFreeShipping) {
    return <CheapMoreShipping isLoading={isLoading} />;
  }

  if (showIncentiveForFreeShipping && quantityForFreeShipping > 1 && experiment === 'NEW') {
    return <FreeShipping isLoading={isLoading} quantityForFreeShipping={quantityForFreeShipping} />;
  }

  return <></>;
};

export default ShippingMessage;
